import { render, staticRenderFns } from "./ListBiotecPlagas.vue?vue&type=template&id=49d626ae&scoped=true"
import script from "./ListBiotecPlagas.vue?vue&type=script&lang=js"
export * from "./ListBiotecPlagas.vue?vue&type=script&lang=js"
import style0 from "./ListBiotecPlagas.vue?vue&type=style&index=0&id=49d626ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d626ae",
  null
  
)

export default component.exports